import { html, View } from 'rune-ts';
import { Files } from '../../../../../entities/pool/public/files';
import klass from '../FanLetterList.module.scss';
import { getResizedUrl } from '../../../../../shared/util/image';
import { ButtonAction } from '../../../../../shared/components/atoms/ButtonAction/ButtonAction';
import { FanLetterFormImageDeleteEvent } from '../events/FanLetterEvents';

class FanLetterFormUploadingImageDeleteButtonAction extends ButtonAction {}

class FanLetterFormUploadingImageView extends View<{ file: Files }> {
  protected override template() {
    if (this.data.file.url) {
      return html` <div class="${klass.uploading_file}">
        <img
          class="${klass.uploading_img}"
          src="${getResizedUrl({
            url: this.data.file.url,
            width: 180 * 2,
            format: 'webp',
            quality: 80,
          })}"
          alt=""
        />
        ${new FanLetterFormUploadingImageDeleteButtonAction({
          klass: klass.uploading_delete,
          label: html`<img
            src="//s3.marpple.co/files/u_29089/2025/3/original/02fb73c6042db3c6f40aa74abd4ee7a74daa4c3f1.svg"
            alt=""
          />`,
        })}
      </div>`;
    }
    return html`<div style="display: none;"></div>`;
  }

  protected override onRender() {
    this.delegate('click', `.${klass.uploading_delete}`, () => {
      this.dispatchEvent(FanLetterFormImageDeleteEvent, {
        bubbles: true,
        detail: {
          file_id: this.data.file.id,
        },
      });
    });
  }
}

export class FanLetterFormUploadingImagesView extends View<{ files: Files[] }> {
  protected override template() {
    const { files } = this.data;
    if (!files.length) {
      return html`<div style="display: none;"></div>`;
    }
    return html` <div class="${klass.uploading_files}">
      ${files.map((file) => {
        return new FanLetterFormUploadingImageView({ file });
      })}
    </div>`;
  }

  getFiles() {
    return this.data.files;
  }

  pushFiles(files: Files[]) {
    this.data.files.push(...files);
    return this;
  }

  deleteFiles(file_id: number) {
    this.data.files = this.data.files.filter(({ id }) => {
      return file_id !== id;
    });
    return this;
  }
}
